<template>

  <article class="c-article__text">
    <div class="u-6/10@tablet u-push-2/10@tablet" v-html="content.text"></div>
  </article>

</template>

<script>
export default {
  name: 'TextContent',
  props: ['content']

}
</script>
